import { Grid, Box } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useEffect, useState, useCallback } from "react";
import { getNewsFailed } from "../../services/NewLegalFileService";
import DatagridCustom from "../General/DatagridCustom";
import { useToast } from "../../context/ToastContext";

export default function NewsLegalFileErrorsTable() {
  const { showToast } = useToast();
  const [newLegalFile, setNewLegalFile] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });

  const fetchNewLegalFile = useCallback(async () => {
    setLoading(true);
    try {
      const { page, pageSize } = paginationModel;
      const searchTerm = filterModel.quickFilterValues?.join(" ") || "";

      const res = await getNewsFailed({
        page: page + 1,
        perPage: pageSize,
        search: searchTerm,
      });

      //console.log(res.data.data);

      showToast(res.data.message, "success");
      setNewLegalFile(res.data.data);
      setTotal(res.data.total);
    } catch (error) {
      console.error(
        "[NewsLegalFile] Error al cargar fallos de novedades:",
        error,
      );
      showToast(
        "No se pudieron cargar las novedades. Intente de nuevo más tarde.",
      "error")
    } finally {
      setLoading(false);
    }
  }, [paginationModel, filterModel, showToast]);

  useEffect(() => {
    fetchNewLegalFile();
  }, [paginationModel, filterModel, fetchNewLegalFile]);

  const handleFilterModelChange = useCallback(
    (newFilterModel) => {
      const currentSearchTerm = filterModel.quickFilterValues?.join(" ") || "";
      const newSearchTerm = newFilterModel.quickFilterValues?.join(" ") || "";

      setFilterModel(newFilterModel);

      if (currentSearchTerm !== newSearchTerm) {
        setPaginationModel((prev) =>
          prev.page !== 0 ? { ...prev, page: 0 } : prev,
        );
      }
    },
    [filterModel],
  );

  const columns = [
    { field: "file_number", headerName: "N° Expediente", flex: 1 },
    { field: "error_message", headerName: "Error", flex: 4 },
    { field: "retry_count", headerName: "Intentos", flex: 1 },
    {
      field: "last_attempt_at",
      headerName: "Último intento",
      flex: 1,
      valueGetter: (params) => {
        const date = new Date(params);

        if (isNaN(date.getTime())) {
          return "Fecha inválida";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
    },
  ];

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

        {/* <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}> */}
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          {/* <DataGrid
                  rows={newLegalFile}
                  columns={columns}
                  getRowId={(row) => row.id}
                  paginationModel={paginationModel}
                  onPaginationModelChange={(newModel) =>
                    setPaginationModel(newModel)
                  }
                  onFilterModelChange={handleFilterModelChange}
                  rowCount={total}
                  paginationMode="server"
                  pageSizeOptions={[10, 20, 50, 100]}
                  loading={loading}
                  disableRowSelectionOnClick
                  showToolbar
                  localeText={{
                    ...toolbarLocaleText,
                    footerRowSelected: () => "",
                  }}
                  slots={{
                    toolbar: CustomToolbar,
                  }}
                  autoHeight
                /> */}
          <DatagridCustom
            rows={newLegalFile}
            columns={columns}
            title="Listado de Novedades Fallidas"
            description="Visualice las novedades que no se lograron registrar.."
            icon={<AssignmentIcon sx={{ fontSize: 32 }} />}
            // error={globalError}
            success={false}
            paginationModel={paginationModel}
            onPaginationChange={setPaginationModel}
            total={total}
            loading={loading}
            filterModel={filterModel}
            onFilterChange={handleFilterModelChange}
            filterMode="server"
            isServerPagination={true}
          />
        </Box>
        {/* </Paper> */}
      </Grid>
    </Grid>
  );
}
